// extracted by mini-css-extract-plugin
export default {"btn_home":"ButtonHome_btn_home__qtism"};